import _ from 'lodash';

const componentName = 'server';
const serviceName = 'DoctorServerRealtimeComponent';
const moduleName = 'doxy.realtime.components.doctor-server';
export { componentName, serviceName, moduleName };
import DoctorServerRealtimeComponent from './doctor/server';

export default angular
  .module(moduleName, [])
  .service(serviceName, DoctorServerRealtimeComponent).name;
